(() => {
  const scrollerSelector = '[data-dz-infinite-scroll]';
  const gridSelector = '[data-dz-infinite-grid]';

  function initInfiniteProducts(root = document) {
    root.querySelectorAll(scrollerSelector).forEach((scroller) => {
      if (scroller.dataset.dzInfiniteReady === 'true') return;

      const section = scroller.closest('[data-dz-infinite-section], .dz-catalog, .dz-search-main, main, body') || document;
      const grid = section.querySelector(gridSelector);
      const status = scroller.querySelector('[data-dz-infinite-status]');
      const fallback = scroller.querySelector('[data-dz-infinite-fallback]');
      let nextUrl = scroller.dataset.nextUrl || '';
      let loading = false;
      let observer = null;

      const setStatus = (message) => {
        if (status) status.textContent = message;
      };

      if (!grid || !nextUrl) {
        scroller.classList.add('is-complete');
        setStatus('All products loaded');
        return;
      }

      scroller.dataset.dzInfiniteReady = 'true';
      if (fallback) fallback.hidden = true;

      const loadNextPage = async () => {
        if (loading || !nextUrl) return;

        loading = true;
        scroller.classList.add('is-loading');
        setStatus('Loading more products...');

        try {
          const response = await fetch(nextUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) throw new Error(`Product page request failed: ${response.status}`);

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector(gridSelector);
          const nextScroller = doc.querySelector(scrollerSelector);

          if (!nextGrid) throw new Error('Next product grid was not found.');

          const products = Array.from(nextGrid.children).filter((item) => item.matches('.product-card, article, li, .grid__item'));
          products.forEach((product) => grid.appendChild(document.importNode(product, true)));

          document.dispatchEvent(new CustomEvent('dzire:products:loaded', {
            detail: { count: products.length, grid }
          }));

          nextUrl = nextScroller?.dataset.nextUrl || '';

          if (nextUrl) {
            scroller.dataset.nextUrl = nextUrl;
            setStatus('Scroll for more products');
            if (observer) observer.observe(scroller);
          } else {
            scroller.classList.add('is-complete');
            setStatus('All products loaded');
            if (observer) observer.disconnect();
            window.setTimeout(() => scroller.setAttribute('hidden', ''), 1400);
          }
        } catch (error) {
          setStatus('Could not auto-load products.');
          if (fallback && nextUrl) {
            fallback.hidden = false;
            fallback.href = nextUrl;
          }
          if (observer) observer.disconnect();
        } finally {
          loading = false;
          scroller.classList.remove('is-loading');
        }
      };

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && nextUrl && !loading) {
            observer.unobserve(scroller);
            loadNextPage();
          }
        });
      }, { rootMargin: '700px 0px 900px' });

      observer.observe(scroller);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initInfiniteProducts());
  } else {
    initInfiniteProducts();
  }

  document.addEventListener('shopify:section:load', (event) => initInfiniteProducts(event.target));
})();
